import * as React from 'react'

import { DataTable } from './DataTable'
import { SortByDropdown } from './SortByDropdown'
import { ArrowDownWideNarrow, Download, Plus } from 'lucide-react'
import { useTranslation } from '../../../hooks/useTranslation'
import { Button } from '../../../lib/ui/button'
import { OutsideJobFormModal } from './OutsideJobFormModal'
import { useIsDesktop } from '../../../hooks/useMediaQuery'
import { cn } from '../../../lib/utils'
import { Filters } from './Filters'

export default function Page() {
  const { t } = useTranslation('Page')

  return (
    <div
      className="flex min-h-[67vh] flex-col gap-4"
      data-testid="saved-jobs-main"
    >
      <h1 className="py-2">
        <span className="font-normal">{t('manage')}</span> {t('my_jobs')}
      </h1>
      <p>{t('explanation')}</p>

      <div className="flex flex-col justify-between gap-4 md:flex-row">
        <SortByDropdownAndLabel />
        <div className="flex flex-row items-center gap-4 self-end">
          <DownloadSavedJobsCsvButton />
          <OutsideJobFormModalButton />
        </div>
      </div>

      <DataTable />
    </div>
  )
}

function SortByDropdownAndLabel() {
  const { t } = useTranslation('Page')
  const isDesktop = useIsDesktop()
  const size = isDesktop ? 20 : 14

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row items-center gap-2 whitespace-nowrap">
        <ArrowDownWideNarrow size={size} />
        <div className="text-sm font-medium sm:text-base">{t('sort_by')}:</div>
        <SortByDropdown />
      </div>
      <div className="flex flex-row flex-wrap items-center gap-4 whitespace-nowrap">
        <Filters />
      </div>
    </div>
  )
}

function DownloadSavedJobsCsvButton() {
  const isDesktop = useIsDesktop()
  const size = isDesktop ? 20 : 14

  return (
    <Button variant="link" asChild className="gap-2 pr-0 text-sm sm:text-base">
      <a
        href="/job-search/saved_jobs.csv"
        data-testid="download-saved-jobs-csv"
      >
        <Download size={size} />
        Download CSV
      </a>
    </Button>
  )
}

function OutsideJobFormModalButton() {
  const { t } = useTranslation('Page')
  const isDesktop = useIsDesktop()
  const size = isDesktop ? 20 : 14

  return (
    <OutsideJobFormModal>
      <Button variant="link" className={cn('gap-2 pr-0 text-sm sm:text-base')}>
        <Plus size={size} />
        {t('add_a_new_saved_job')}
      </Button>
    </OutsideJobFormModal>
  )
}
